import type { HTMLAttributes } from 'react'
import { cn } from '../../lib/cn'

/** Flat panel: ring, no shadow. `hover` adds the doWallet hover ring. */
export function Card({ className, size = 'default', hover, ...props }: HTMLAttributes<HTMLDivElement> & { size?: 'default' | 'sm'; hover?: boolean }) {
  return (
    <div
      className={cn(
        'group/card flex flex-col gap-(--card-spacing) overflow-hidden rounded-xl bg-card py-(--card-spacing) text-sm text-card-foreground ring-1 ring-foreground/10',
        size === 'sm' ? '[--card-spacing:--spacing(3)]' : '[--card-spacing:--spacing(4)]',
        hover && 'transition-shadow hover:ring-foreground/20',
        className,
      )}
      {...props}
    />
  )
}
export function CardHeader({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('flex flex-col gap-1 px-(--card-spacing)', className)} {...props} />
}
export function CardTitle({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cn('font-heading text-base leading-snug font-medium', className)} {...props} />
}
export function CardDescription({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('text-sm text-muted-foreground', className)} {...props} />
}
export function CardContent({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('px-(--card-spacing)', className)} {...props} />
}
export function CardFooter({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('-mb-(--card-spacing) flex items-center gap-2 rounded-b-xl border-t bg-muted/50 px-(--card-spacing) py-3', className)} {...props} />
}
